import store from '@/store';
import { p2pActions } from '@/store/p2p-slice';

import { sendP2PSocketData } from './p2pConnection';

export const onP2POpenHandler = async () => {
    store.dispatch(p2pActions.updateP2PSConnection('Connection Open'));
    const isInUploadKeyPage = store.getState().p2pReducer.isInUploadKeyPage;
    const activeServerId = store.getState().serverDataReducer.activeServer;
    const token = store.getState().userReducer.user?.token;

    if (token && activeServerId) {
        sendP2PSocketData({
            command: 'login',
            data: { token: token, subserver_id: activeServerId },
        });
    }

    if (isInUploadKeyPage) {
        store.dispatch(p2pActions.updatePeerFound('Connection Open'));
    }

};
